import axios from 'axios'

class HealthRecordService {
  constructor() {
    this.baseUrl = '/api/v1/'
  }

  getHealthRecord() {
    return axios.get(`${this.baseUrl}hr/`)
  }

  setHealthRecordData(data) {
    localStorage.setItem('healthrecord', JSON.stringify(data))
  }

  getHealthRecordData() {
    return JSON.parse(localStorage.getItem('healthrecord'))
  }

  vaidateUrl(obj) {
    return axios.post(`${this.baseUrl}sharing/confirm-hr-link/`, obj)
  }

  vaidateDocumentUrl(obj) {
    return axios.post(`${this.baseUrl}healthvaults/link-validation/`, obj)
  }

  getHealthRecordDataPatinet(obj) {
    return axios.post(`${this.baseUrl}hr/get-senders-hr-records`, obj)
  }

  verifyDocumentRecipientInfo(data) {
    return axios.post(
      `${this.baseUrl}healthvaults/validate-recipient-details/`,
      data
    )
  }

  getReceiverRecords() {
    return axios.get(`${this.baseUrl}sharing/get-received-hr-details/`)
  }

  getSaharedHealthRecord() {
    return axios.get(`${this.baseUrl}sharing/get-shared-hr-details/`)
  }

  revokeAccess(data) {
    return axios.post(`${this.baseUrl}sharing/hr-update-revoke-access/`, data)
  }

  getSharedRecordByQRCode() {
    return axios.post(`${this.baseUrl}qr/get-qr-shared-hr-details/`, '')
  }

  validateQrUrl(obj) {
    return axios.post(`${this.baseUrl}qr/qr-link-validation-details/`, obj)
  }
}

export const healthRecordService = new HealthRecordService()
